import { LG_COLOR } from 'containers/App/constants';
import { NavDropdown } from 'react-bootstrap';
import styled from 'styled-components';

export const UserInfoStyles = styled(NavDropdown)`
  position: static;

  .user-container {
    height: 40px;
    width: 40px;
    background-color: #006e7d;

    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;

    border-radius: 50px;

    color: white;
  }

  .dropdown-toggle {
    text-decoration: none;
    &::after {
      content: unset;
    }
  }
`;
